<template>
  <div>
    <div class="row">
      <div class="col-6 d-flex flex-column align-items-center">
        <div class="input-wrapper">
          <label>Concept name</label>
          <el-input placeholder="Input data"
                    v-model="filters.conceptDetails.name.value"
                    clearable></el-input>
        </div>
        <div class="input-wrapper" style="margin-top: 17px">
          <label>Concept theme</label>
          <el-select
              v-model="filters.conceptDetails.theme.value" collapse-tags
              placeholder="Select values" filterable multiple @change="updateDropdownValues()"
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getConceptTagValues('theme')"
                  :key="value.value" :label="value.value" :value="value.value">
                <span style="float: left">{{value.value}}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="input-wrapper" style="margin-top: 17px">
          <label>Region of the concept</label>
          <el-select
            :value="filters.conceptDetails.region.value"
            @change="val => changeRegionData(val, 'concepts')"
            placeholder="Select data" multiple filterable collapse-tags>
              <el-option-group label="Press Tab/Escape to exit">
                <template v-for="value in getConceptTagValues('region')">
                  <el-option
                      v-if="!['APAC-South Asia', 'APAC-South East Asia', 'APAC-North Asia'].includes(value.value)"
                      :key="value.value" :label="value.value"
                      :value="value.value">
                    <span style="float: left">{{value.value}}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                  </el-option>
                </template>
                <template v-for="value in getAPACcounts('fragrance')">
                  <el-option v-if="value.value === 'APAC'" :key="value.value" :label="value.value"
                             :value="value.value">
                    <span style="float: left">{{value.value}}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                  </el-option>
                  <el-option v-else :key="value.value" :label="value.value"
                             :value="value.value">
                    <span style="float: left; margin-left: 10px">{{value.value}}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                  </el-option>
                </template>
              </el-option-group>
            </el-select>
        </div>
      </div>
      <div class="col-6 d-flex flex-column align-items-center">
        <div class="input-wrapper">
          <label>Ingredient 1</label>
          <el-select
              v-model="filters.conceptDetails.ingredient1.value" collapse-tags
              placeholder="Select values" filterable multiple @change="updateDropdownValues()"
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getConceptTagValues('ingredient1')"
                  :key="value.value" :label="value.value" :value="value.value">
                <span style="float: left">{{value.value}}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="input-wrapper" style="margin-top: 17px">
          <label>Ingredient 2</label>
          <el-select
              v-model="filters.conceptDetails.ingredient2.value" collapse-tags
              placeholder="Select values" filterable multiple @change="updateDropdownValues()"
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getConceptTagValues('ingredient2')"
                  :key="value.value" :label="value.value" :value="value.value">
                <span style="float: left">{{value.value}}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="input-wrapper" style="margin-top: 17px">
          <label>Country of the concept</label>
          <el-select
              v-model="filters.conceptDetails.country.value" collapse-tags
              placeholder="Select values" filterable multiple @change="updateDropdownValues()"
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getConceptTagValues('country')"
                  :key="value.value" :label="value.value" :value="value.value">
                <span style="float: left">{{value.value}}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tooltips from '../../../constants/tooltips'
import _ from 'lodash'

export default {
  name: 'FragranceDetailsForm',
  props: {
    filters: Object,
    getMetadataTagValues: Function,
    updateDropdownValues: Function,
    getConceptTagValues: Function,
    getAPACcounts: Function
  },
  data () {
    return {
      tooltips
    }
  },
  methods: {
    changeRegionData (data, targetObj) {
      const mainRegion = 'APAC'
      const subRegions = ['APAC-South Asia', 'APAC-South East Asia', 'APAC-North Asia']
      if (data.includes(mainRegion)) {
        if (!this.previousRegionValues.includes(mainRegion)) {
          data = [...new Set([...data, ...subRegions])]
        } else {
          if (data.filter(el => el !== mainRegion).length < 3) {
            const index = data.indexOf(mainRegion)
            data.splice(index, 1)
          }
        }
      } else {
        if (this.previousRegionValues.includes(mainRegion)) {
          data = data.filter(x => !subRegions.includes(x))
        }
      }
      this.$set(this.filters[targetObj].region, 'value', data)
      this.previousRegionValues = data
      this.updateDropdowns(_.cloneDeep(this.filters))
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variables";

.input-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

.input-wrapper input {
  width: 100%;
}

.input-wrapper .el-select {
  width: 100%;
}

.input-wrapper label {
  color: $input-label;
  margin-bottom: 2px;
  margin-left: 2px;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 13px;
  line-height: 20px;
  font-weight: 600;
}
</style>
